import { Paper, Text, Badge, Progress, Flex, Stack, Box } from "@mantine/core";

// Colores para las fuentes
const SOURCE_COLORS = [
    "blue", "green", "violet", "orange", "cyan", "pink", "teal", "indigo", "grape", "lime"
];

/**
 * Efectividad por fuente de leads (leadSource).
 * Muestra volumen, conversiones y tasa de conversión por canal.
 */
export default function LeadSourceChart({ sources }) {
    if (!sources || sources.length === 0) {
        return (
            <Paper shadow="sm" radius="md" p="lg">
                <Text fw={600} size="lg" mb="sm">
                    Efectividad por fuente
                </Text>
                <Text size="sm" c="dimmed">
                    No hay datos de fuentes para el período seleccionado.
                </Text>
            </Paper>
        );
    }

    return (
        <Paper shadow="sm" radius="md" p="lg">
            <Text fw={600} size="lg" mb="md">
                Efectividad por fuente
            </Text>

            <Stack gap="md">
                {sources.map((source, idx) => {
                    const color = SOURCE_COLORS[idx % SOURCE_COLORS.length];

                    return (
                        <Box key={source.source}>
                            <Flex justify="space-between" align="center" mb={4}>
                                <Text size="sm" fw={500}>
                                    {source.source}
                                </Text>
                                <Flex gap="sm" align="center">
                                    <Text size="xs" c="dimmed">
                                        {source.totalLeads} leads
                                    </Text>
                                    <Text size="xs" c="dimmed">
                                        ·
                                    </Text>
                                    <Text size="xs" c="green" fw={500}>
                                        {source.converted} conv.
                                    </Text>
                                    <Badge
                                        variant="light"
                                        color={source.conversionRate >= 20 ? "green" : source.conversionRate >= 10 ? "yellow" : "red"}
                                        size="sm"
                                    >
                                        {source.conversionRate}%
                                    </Badge>
                                </Flex>
                            </Flex>
                            <Progress.Root size="lg" radius="sm">
                                <Progress.Section
                                    value={(source.converted / Math.max(source.totalLeads, 1)) * 100}
                                    color="green"
                                />
                                <Progress.Section
                                    value={(source.lost / Math.max(source.totalLeads, 1)) * 100}
                                    color="red"
                                />
                                <Progress.Section
                                    value={
                                        ((source.totalLeads - source.converted - source.lost) /
                                            Math.max(source.totalLeads, 1)) *
                                        100
                                    }
                                    color={color}
                                />
                            </Progress.Root>
                        </Box>
                    );
                })}
            </Stack>

            {/* Leyenda */}
            <Flex gap="md" mt="md" justify="center">
                <Flex align="center" gap={4}>
                    <Box style={{ width: 12, height: 12, borderRadius: 2, backgroundColor: "var(--mantine-color-green-6)" }} />
                    <Text size="xs" c="dimmed">Convertidos</Text>
                </Flex>
                <Flex align="center" gap={4}>
                    <Box style={{ width: 12, height: 12, borderRadius: 2, backgroundColor: "var(--mantine-color-red-6)" }} />
                    <Text size="xs" c="dimmed">Perdidos</Text>
                </Flex>
                <Flex align="center" gap={4}>
                    <Box style={{ width: 12, height: 12, borderRadius: 2, backgroundColor: "var(--mantine-color-blue-6)" }} />
                    <Text size="xs" c="dimmed">En proceso</Text>
                </Flex>
            </Flex>
        </Paper>
    );
}
